import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

/**
 * How far back the video integration service still queries a vendor for sessions.
 *
 * A synchronization run clamps its window to this bound, so a cursor set before it promises a
 * backlog that is never fetched — the service rejects such a request rather than adjusting it.
 * Mirrors `SESSION_SYNC_MAXIMUM_LOOKBACK_HOURS` on production.
 */
export const SYNC_CURSOR_LOOKBACK_DAYS = 30;

export type UpdateSyncCursorPayload = z.output<typeof updateSyncCursorPayloadSchema>;
export type UpdateSyncCursorPayloadDTO = z.input<typeof updateSyncCursorPayloadSchema>;

/**
 * Where the next synchronization run should carry on from.
 *
 * Only the bounds that hold no matter when the request is handled are checked here; whether the
 * instant still falls inside the lookback window is the video integration service's call, because
 * only it knows the window it is configured with.
 */
export const updateSyncCursorPayloadSchema = z.object({
  lastSynced: isoDatetimeToDate,
});
